import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-end justify-center text-center sm:items-center sm:p-8" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-5 sm:px-6 bg-white relative overflow-hidden border-b border-gray-200" }
const _hoisted_4 = { class: "card-heading" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = {
  id: "modal-content",
  class: "px-4 sm:px-6"
}

import {
		PropType,
		ref
	} from 'vue'
	import {
		Dialog,
		DialogPanel,
		DialogTitle,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'
	import {
		XMarkIcon
	} from '@heroicons/vue/24/outline'

	/*eslint-disable*/
	
  // name the component
	const __default__ = { name: 'TwModal' }
  
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		description: {
			type: String,
			default: ""
		},
		modalMaxWidth: {
			type: String,
			default: 'max-w-screen-xl'
		},
		title: {
			type: String,
			default: ""
		},
		closeModal:{
			type: Function,
			default: () => {return}
		},
		initialFocus: {
			type: Object as PropType<HTMLElement | null>,
			default: null
		}
	},
  setup(__props, { expose: __expose }) {

	const props = __props
  
	const open = ref(false)

	__expose({
		open
	})
  
return (_ctx: any,_cache: any) => {
  const _component_card_header_backdrop = _resolveComponent("card-header-backdrop")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-40",
        "initial-focus": __props.initialFocus,
        onClose: _cache[1] || (_cache[1] = () => {open.value = false; __props.closeModal()})
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
            ])),
            _: 1,
            __: [2]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.modalMaxWidth,'relative transform overflow-x-hidden overflow-y-auto rounded-lg bg-white h-200 pb-4 text-left shadow-xl transition-all sm:my-8 w-full sm:pb-4'])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(DialogTitle), null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(XMarkIcon), {
                            class: "h-5 w-5 text-gray-700 hover:text-brand-500 cursor-pointer",
                            onClick: _cache[0] || (_cache[0] = () => {open.value = false; __props.closeModal()})
                          })
                        ]),
                        _createVNode(_component_card_header_backdrop, { class: "opacity-20" })
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "default")
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      }, 8, ["initial-focus"])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})